import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { isUsableFootage, usageCounts } from '../../footage/footageView';
import { useMusicVideoEditor } from '../../MusicVideoEditorContext';
import { footageMessages } from '../../messages/footageMessages';
import { ClipCard } from './ClipCard';
import { useAddClip } from './useAddClip';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The clips of Yours that the Bank tab shows (design b1). */
const PREVIEW_COUNT = 2;

/** "Yours · N clips" under the bank (design b1), with "All" to the Yours tab. */
const YoursPreviewComponent: React.FC<{ onShowAll: () => void }> = ({ onShowAll }) => {
  const intl = useIntl();
  const { footage, doc } = useMusicVideoEditor();
  const { add } = useAddClip();
  const ready = useMemo(() => footage.own.filter(isUsableFootage), [footage.own]);
  const uses = useMemo(() => usageCounts(doc.clips), [doc.clips]);
  const shown = useMemo(() => ready.slice(0, PREVIEW_COUNT), [ready]);
  if (ready.length === 0) {
    return null;
  }
  return (
    <>
      <div className={styles.sectionHead}>
        <b>{intl.formatMessage(footageMessages.yoursHeading)}</b>
        <small>{intl.formatMessage(footageMessages.yoursFacts, { count: ready.length })}</small>
        <span className={styles.grow} />
        <button type="button" className={styles.linkButton} onClick={onShowAll}>
          {intl.formatMessage(footageMessages.all)}
        </button>
      </div>
      <div className={styles.clipGrid}>
        {shown.map((view) => (
          <ClipCard key={view.key} view={view} uses={uses.get(view.key) ?? 0} showSource onPick={add} />
        ))}
      </div>
    </>
  );
};

export const YoursPreview = TypedMemo(YoursPreviewComponent);
